export default {
  disabled: {
    title: 'Facturering wordt niet beheerd op het platform',
    description:
      'Abonnementen en facturen zijn niet beschikbaar omdat de facturering tussen u en uw restaurants buiten het platform wordt afgehandeld. Uitbetalingen, overzichten en rapporten blijven beschikbaar.',
  },
};
